import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { ApiService } from './api.service';

export class Helpme implements CanActivate {
  x = false;
   canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean {
    var c = `${localStorage.getItem('permission')}`;
    var p = JSON.parse(c);
    p.data.forEach((element: any) => {
      if (element.name == route.data.name) {
        if (element.checked === 1){
          this.x = true;
        } else {
          this.x = false;
        }
      }
    });
    return this.x;
  }

}
